module.exports = __webpack_public_path__ + "img/fushimi-HP-003.b18e3822.jpg";